/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "載入中"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var zhTW = Object.assign(TranslationProviderComponent, {
  translations
});

export { zhTW as z };
//# sourceMappingURL=zh-TW-5mY-4ulK.js.map
